module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "news-top-left.025fa2c7.jpeg" + "?" + Date.now();